import React from "react";

export const StepIcon = ({ className, color = "#DB4E3B", width = "32", height = "32" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.5002 3C11.5002 4.65685 10.1571 6 8.50023 6C6.84338 6 5.50023 4.65685 5.50023 3C5.50023 1.34315 6.84338 0 8.50023 0C10.1571 0 11.5002 1.34315 11.5002 3Z"
        fill={color}
      />
      <path
        d="M5.37912 7.50345C5.66377 7.18322 6.07178 7 6.50023 7H9.38945C10.8737 7 12.0311 8.28561 11.8757 9.76171L11.0164 17.9255C10.988 18.1947 10.9285 18.4598 10.8391 18.7153L10.2049 20.5274L10.6291 21.0122C10.7211 21.1174 10.798 21.2349 10.8575 21.3613L14.8575 29.8613C15.2102 30.6109 14.8885 31.5045 14.1389 31.8572C13.3894 32.21 12.4957 31.8883 12.143 31.1387L8.23268 22.8293L4.87137 18.9878C4.61418 18.6938 4.48178 18.3112 4.50231 17.9212L4.77731 12.6961L3.90872 13.6733L2.97983 19.2466C2.84363 20.0638 2.07079 20.6158 1.25364 20.4796C0.43648 20.3434 -0.115549 19.5706 0.0206432 18.7534L1.02064 12.7534C1.0671 12.4746 1.19137 12.2147 1.37912 12.0035L5.37912 7.50345Z"
        fill={color}
      />
      <path
        d="M5.00032 23.4897V20.6536L7.40761 23.4048L7.93081 24.4512C7.87836 24.6175 7.79698 24.7744 7.68925 24.9145L2.68925 31.4145C2.18415 32.0711 1.24238 32.1939 0.585753 31.6888C-0.0708786 31.1837 -0.193718 30.242 0.311383 29.5853L5.00032 23.4897Z"
        fill={color}
      />
      <path
        d="M13.4397 15.0606L12.452 14.0729L12.8616 10.3864C12.8666 10.3415 12.8707 10.2968 12.8739 10.2522L15.1216 12.4999H18.0003C18.8287 12.4999 19.5003 13.1715 19.5003 13.9999C19.5003 14.8283 18.8287 15.4999 18.0003 15.4999H14.5003C14.1025 15.4999 13.721 15.3419 13.4397 15.0606Z"
        fill={color}
      />
    </svg>
  );
};

